import { render, staticRenderFns } from "./salesperson-lead-show.vue?vue&type=template&id=72986f5a&scoped=true&"
import script from "./salesperson-lead-show.vue?vue&type=script&lang=js&"
export * from "./salesperson-lead-show.vue?vue&type=script&lang=js&"
import style0 from "./salesperson-lead-show.vue?vue&type=style&index=0&id=72986f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72986f5a",
  null
  
)

export default component.exports